module.exports = __webpack_public_path__ + "img/BOR_botanical-gardens.012c9623.webp";